import { render, staticRenderFns } from "./SelectPatient.vue?vue&type=template&id=2e9b113a"
import script from "./SelectPatient.vue?vue&type=script&lang=ts"
export * from "./SelectPatient.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports